<template>
  <div>    
    <div class="form-group">
       <multiselect 
        v-model="valorDefinido"
        :id="idDelInput"
        :value="tipo.Id"
        :options="Areas"
        select-label=""           
        :show-labels="false"
        :placeholder="placeholder"
        @select="cambioOrigen"
        label="Descripcion"
        @search-change="updateSearchText"
       >
        <span slot="noResult" @click="agregaElemento">Doble Click Para Agregar</span>
      </multiselect>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import Multiselect from 'vue-multiselect'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default
  {
    components:{Multiselect},
    data(){
      return {
        enumeraciones,
        comun,
        Areas:[],
        desHabilitaEdicion:true,
        idDelModelo: null,
        searchText: '',
        valorDefinido: Number
      }
    },//Data
    props: {
      prefijo: Number,
      parametros: Object,
      placeholder: String, 
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo,
        Ordenamiento: this.idOrden,
      }
      this.$store.dispatch("A_PJ_Catalogos_EstablecerOrigenOficio", params);
    },
    methods: {
    CargarCatalogoDeAreas(){
      let peticion = {
        EsPrueba: comun.EsPrueba,
        Ordenamiento: 1
      }
      axios.post(api.conexion + api.TemisCivil.catalogos.AreasRecepcion, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Areas = respuesta.data.AreasRecepcion;
              this.idDelModelo = this.Areas[0].AreaID;
              return respuesta.data.AreasRecepcion;
            }
          }).catch(e => {
            console.log(e);
         });
    },//CargarCatalogoDeAnexos
    agregaElemento:function(e){
      var AId = this.Areas.length;
      var Nom = this.searchText;
      var AIde = AId;
      this.Areas.push({AreaID:AId, Descripcion:Nom});
    },
    updateSearchText(query) {
        this.searchText = query;
    },
    cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogos_EstablecerOrigenOficio", parametros);
        this.$emit("valorParaElPadre", evento);
      },
      cambioOrigen (evento) {
        this.$emit("valorParaElPadre", evento);
      }
    },//Methods
    created() {
      this.CargarCatalogoDeAreas();
    }
  }

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight {
  background: #504f54;
}

.multiselect__option--selected.multiselect__option--highlight{
  background: #007bff;
}
</style>


// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/OrigenOficioOtro.vue